import styled from "styled-components";

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  background-color: var(--raised-background-color);
`;
export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1280px;
  width: calc(100% - 4rem);
  padding-bottom: 4rem;
  @media screen and (max-width: 768px) {
    align-items: flex-start;
    padding-bottom: 0;
  }
`;
export const StyledTitleAbove = styled.a`
  font-size: 0.75rem;
  padding: 4rem 0 2rem 0;
  text-decoration: none;
  color: var(--text-color);
  font-weight: 700;
  font-size: 19px;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  > svg {
    height: 14px;
    width: auto;
    fill: var(--text-color);
    margin-right: 16px;
  }
  @media screen and (max-width: 768px) {
    padding: 2rem 0;
  }
  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`;
export const StyledTitle = styled.div`
  font-size: 3rem;
  line-height: 4.2rem;
  color: var(--text-color);
  font-weight: 700;
  @media screen and (max-width: 768px) {
    font-size: 2rem;
    line-height: 2.8rem;
  }
`;
export const StyledTitleBelow = styled.div`
  color: var(--text-color);
  font-size: 1.2rem;
  text-align: center;
  width: 40%;
  padding: 2rem 9px;
  @media screen and (max-width: 768px) {
    width: 100%;
    text-align: left;
    padding: 1rem 0 2rem 0;
  }
`;
